import { Onboarding } from '@/services/requests/onboarding/Onboarding.types';

export const ANNUAL_TURNOVERS = [
  'ZERO_TO_1000',
  'K1000_TO_10K',
  'K10K_TO_100K',
  'K100K_AND_ABOVE',
] as const;

export const ONBOARDING_BUSINESS_STAGES = [
  'COMPANY_DETAILS',
  'ACCOUNT_MANAGER',
  'CORPORATE_DOCS',
  'DIRECTORS_SHAREHOLDERS',
  'LIVENESS_CHECK',
  'CONTRACT',
  'RISK_LEVEL',
] as const;

export enum RiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}
export const ONBOARDING_RISK_LEVELS = [...Object.values(RiskLevel)] as const;

export enum BusinessActorRole {
  'ACCOUNT_MANAGER' = 'ACCOUNT_MANAGER',
  'DIRECTOR' = 'DIRECTOR',
  'SHAREHOLDER' = 'SHAREHOLDER',
}
export const BUSINESS_ACTOR_ROLES = [...Object.values(BusinessActorRole)] as const;

export const ONBOARDING_BUSINESS_TYPES = [
  'PARTNERSHIP',
  'LIMITED_LIABILITY_PARTNERSHIP',
  'LIMITED_COMPANY',
] as const;

export const ONBOARDING_PURPOSES = [
  'RECEIVE_PAYMENTS',
  'BUSINESS_EXPENSES',
  'SALARIES',
  'INTERNATIONAL_PAYMENTS',
] as const;

export const BUSINESS_INDUSTRIES = [
  'ACTIVITIES_OF_HEAD_OFFICES',
  'ADULT_ENTERTAINMENT',
  'ADVERTISING_AGENCIES',
  'AFFILIATE_MARKETING',
  'AGRICULTURE',
  'ARCHITECTURE_AND_INTERIOR_DESIGN',
  'ART',
  'ART_GALLERY',
  'ARTIFICIAL_INTELLIGENCE',
  'AUDIO_AND_VIDEO_PRODUCTION',
  'AUTOMOTIVE_INCLUDING_PARTS_AND_ACCESSORIES',
  'AUTOMOTIVE_USED_CARS_AND_HEAVY_INDUSTRY_VEHICLES',
  'BABY_PRODUCTS_EXCLUDING_APPAREL',
  'BANKING',
  'BEAUTY_PRODUCTS_AND_SERVICES',
  'BEVERAGES',
  'BLOCKCHAIN_TECHNOLOGY',
  'BOOKKEEPING',
  'BOOKS',
  'BRANDING_DESIGN',
  'BROKERING_AND_OTHER_CONSULTING',
  'CALL_CENTRES',
  'CARGO_AND_LOGISTICS',
  'CATERING_AND_FOOD_DELIVERY',
  'CLEANING_REPAIR_AND_MAINTENANCE_SERVICES',
  'CLOTHING_AND_BEAUTY_PRODUCTS',
  'CLOUD_COMPUTING',
  'COACHING_AND_TRAINING',
  'COLLECTIBLES_AND_GIFTS_INCLUDING_ANTIQUES',
  'COMPANY_ESTABLISHMENT_OR_FORMATION_SERVICE',
  'CONSTRUCTION',
  'CONTENT_MARKETING',
  'CROWDFUNDING_PLATFORMS',
  'CRYPTO_EXCHANGES',
  'CRYPTOCURRENCY_SERVICES',
  'DATA_PROCESSING_AND_HOSTING',
  'DATING',
  'DIGITAL_MARKETING',
  'DIRECT_MARKETING',
  'DOCTORS_AND_OTHER_MEDICAL_SERVICES',
  'E_CIGARETTES',
  'ELECTRONICS',
  'EMPLOYMENT_AND_HUMAN_RESOURCE_SERVICES',
  'ESCORT_SERVICES',
  'EVENT_MARKETING',
  'EVENTS_AND_ENTERTAINMENT',
  'EXPORT_AND_IMPORT_SERVICES',
  'FAKE_GOODS_OR_COUNTERFEIT_CONSUMER_PRODUCTS',
  'FASHION_JEWELLERY',
  'FINANCIAL_CONSULTING_ACCOUNTING_TAX_OR_AUDIT',
  'FINANCIAL_SERVICES_ACCOUNTING_TAX_OR_AUDIT',
  'FINE_ART_DEALERS_AUCTION_HOUSES_AND_PAWN_BROKERS',
  'FINE_JEWELLERY_AND_WATCHES',
  'FITNESS_SERVICES',
  'FOOD_AND_GROCERY',
  'FUNDS_SPVS_OR_SPES',
  'FX_AND_REMITTANCE_SERVICES',
  'GAMBLING_BETTING',
  'GRAPHICS_DESIGN',
  'HEALTHCARE',
  'HOLDING_COMPANIES',
  'HOME_AND_OUTDOOR_FURNITURE_TOOLS_PRODUCTS',
  'HOTELS_AND_ACCOMMODATION',
  'ILLUSTRATION',
  'INDUSTRIAL_CHEMICALS',
  'INFLUENCER_MARKETING',
  'INSURANCE',
  'INTERIOR_DESIGN',
  'IT_CONSULTING',
  'IT_INFRASTRUCTURE',
  'IT_SECURITY',
  'LAW_ENFORCEMENT_AND_SECURITY',
  'LEGAL_HIGH_OR_CANNABINOIDS',
  'LEGAL_SERVICES',
  'LIVE_STREAMING',
  'LOAN_SERVICES',
  'LUXURY_GOODS',
  'MANAGEMENT_CONSULTING',
  'MANUFACTURING',
  'MANUFACTURING_OF_MACHINERY_AND_EQUIPMENT',
  'MEDICAL_EQUIPMENT',
  'MUSICAL_INSTRUMENTS',
  'NEWS_MEDIA_AND_JOURNALISM',
  'NURSING_AND_CARE_SERVICES',
  'OFFICE_SUPPLIES',
  'ONLINE_EDUCATION_AND_LEARNING',
  'ONLINE_TRADING_OR_BROKERAGE',
  'OTHER_CONSULTING',
  'OTHER_FINANCIAL_SERVICES',
  'OTHER_MANUFACTURING',
  'OTHER_RETAIL_OR_WHOLESALE',
  'OTHER_SERVICES',
  'OTHER_TRANSPORT_SERVICES',
  'OTHERS',
  'PASSENGER_TRANSPORT',
  'PERFORMING_ARTS',
  'PET_AND_PET_SUPPLIES',
  'PETROLEUM_INDUSTRY_SELL_REFINE_OR_TRANSPORT_ANY_PETROLEUM_PRODUCTS',
  'PHARMACEUTICALS',
  'PHOTOGRAPHY',
  'PRECIOUS_METALS_AND_STONES',
  'PRODUCT_DESIGN',
  'PUBLIC_ADMINISTRATION',
  'PUBLIC_RELATIONS_PR',
  'PUBLISHING',
  'RAW_MATERIALS_AND_LIVESTOCK',
  'REAL_ESTATE_DEVELOPMENT',
  'REAL_ESTATE_SALE_PURCHASE_MANAGEMENT',
  'REGULATED_MONEY_SERVICE_BUSINESSES',
  'RENOVATION_AND_RESTORATION',
  'RESTAURANTS_AND_MOBILE_FOOD_STANDS',
  'RIDESHARING_OR_TAXI_SERVICES',
  'ROBOADVISORY',
  'SALES_AND_MARKETING_CONSULTING',
  'SCHOOLS_AND_UNIVERSITIES',
  'SCIENTIFIC_OR_TECHNICAL_CONSULTING',
  'SEARCH_ENGINE_OPTIMISATION_SEO',
  'SOCIAL_CARE',
  'SOCIAL_MEDIA',
  'SOCIAL_MEDIA_MARKETING',
  'SOFTWARE_AS_A_SERVICE',
  'SOFTWARE_DEVELOPMENT',
  'SPORTS_EQUIPMENT',
  'TEACHER_TRAINING_AND_EDUCATION',
  'TEACHING_AND_TUTORING',
  'TEXTILES',
  'TOBACCO',
  'TOUR_OPERATORS',
  'TOYS_AND_GAMES',
  'TRAVEL_AGENCIES',
  'TRUSTS',
  'UI_UX_DESIGN',
  'UNREGULATED_MONEY_SERVICE_BUSINESSES',
  'VENTURE_CAPITAL_OR_PRIVATE_EQUITY_INVESTMENTS',
  'VIDEO_GAMES',
  'VIDEO_MARKETING',
  'VITAMINS_AND_SUPPLEMENTS',
  'WEALTH_MANAGEMENT_AND_PRIVATE_BANKING',
  'WEALTH_MANAGEMENT_TECHNOLOGY',
  'WEAPONS_AND_AMMUNITION',
  'WEB_AND_MOBILE_APPLICATION_DEVELOPMENT',
  'WEB_DESIGN',
  'WEB_HOSTING_AND_WEB_DESIGN',
  'WINE_BEER_AND_SPIRITS',
] as const;

export enum FundsSource {
  SALARY = 'SALARY',
  SAVINGS = 'SAVINGS',
  INVESTMENTS = 'INVESTMENTS',
  INHERITANCE_OR_GIFTS = 'INHERITANCE_OR_GIFTS',
  WINNINGS = 'WINNINGS',
  UNSPECIFIED = 'UNSPECIFIED',
}
export const FUNDS_SOURCE = [...Object.values(FundsSource).filter((source) => source !== 'UNSPECIFIED')] as const;

export enum AccountCurrency {
  EUR = 'EUR',
  GBP = 'GBP',
}
export const ONBOARDING_ACCOUNT_CURRENCIES = [...Object.values(AccountCurrency)] as const;

export const ONBOARDING_BUSINESS_DICT = {
  Stages: ONBOARDING_BUSINESS_STAGES,
  BusinessActorRole: BUSINESS_ACTOR_ROLES,
  BusinessType: ONBOARDING_BUSINESS_TYPES,
  Purpose: ONBOARDING_PURPOSES,
  AnnualTurnover: ANNUAL_TURNOVERS,
  BusinessIndustry: BUSINESS_INDUSTRIES,
  FundsSource: FUNDS_SOURCE,
  AccountCurrency: ONBOARDING_ACCOUNT_CURRENCIES,
} as const;

// DEBT: Move enums to Onboarding.types.ts or move to another file to prevent circular imports
export const USER_EDITABLE_ONBOARDING_STATUSES: Onboarding.ApplicationStatus[] = [
  'ONBOARDING',
  'NO_RESPONSE',
];

export const USER_DOCUMENTS_READONLY_ONBOARDING_STATUSES: Onboarding.ApplicationStatus[] = [
  'ONBOARDING',
];
